import React from 'react';
import {Switch, Route} from "react-router-dom";

// Login Auth
import PrivateRoute from "./utils/PrivateRoute";
import PublicRoute from "./utils/PublicRoute";

import Login from './page/login';
import Dashboard from './page/dashboard';
import Daily from './page/daily';
import Statistics from './page/statistic';

import Proposal from './page/proposal';
import Details from './page/proposal/detail';
import Request from './page/request';

import Items from './page/items';
import ItemsList from './page/items/list';
import ItemsWaiting from './page/items/waiting';

import AddItem from './page/items/add';
import DetailItem from './page/items/edit';
import ListGroup from './page/items/group_unit'
import PurchaseOrder from './page/po';
import Account from './page/dashboard/account';

import SUPPLIER from './page/supplier'
import SuppliersList from './page/supplier/list'
import ADDSUPPLIER from './page/supplier/add'
import DETAILSUPPLIER from './page/supplier/edit'

import UsersListGrouped from './page/users/list'
import Sites from './page/sites';
import TestConsole from './page/test-console';

console.log('📦 App.js - Daily component imported');

export default  function App() {
  console.log('📦 App.js - App component rendered');
  return (
    <Switch> 
      <PublicRoute exact path="/" component={Login} />
      <PrivateRoute exact path="/dashboard" component={Dashboard} />
      <PrivateRoute exact path="/daily" component={Daily} />
      <PrivateRoute exact path="/statistics" component={Statistics} />
      <PrivateRoute exact path="/sites" component={Sites} />

      <PrivateRoute exact path="/detail/proposal/:IDPP" component={Details} />
      <PrivateRoute exact path="/waiting/proposal" component={Proposal} />
      <PrivateRoute exact path="/waiting/request" component={Request} />
      <PrivateRoute exact path="/purchase/order" component={PurchaseOrder} />
      
     
      <PrivateRoute exact path="/list/item" component={Items} />
      <PrivateRoute exact path="/items" component={ItemsList} />
      <PrivateRoute exact path="/list/group/unit" component={ListGroup} />
      <PrivateRoute exact path="/list/item/waiting" component={ItemsWaiting} />
      <PrivateRoute exact path="/add/item" component={AddItem} />
      <PrivateRoute exact path="/detail/item/:IDITEM" component={DetailItem} />

      <PrivateRoute exact path="/account/setting" component={Account} />
      
      {/* Users */}
      <PrivateRoute exact path="/users" component={UsersListGrouped} />

      {/* Supplier */}
      <PrivateRoute exact path="/list/supplier" component={SUPPLIER} />
      <PrivateRoute exact path="/suppliers" component={SuppliersList} />
      <PrivateRoute exact path="/add/supplier" component={ADDSUPPLIER} />
      <PrivateRoute exact path="/detail/supplier/:IDSUPP" component={DETAILSUPPLIER} />
      
      {/* Test route - remove after testing */}
      <Route exact path="/test-console" component={TestConsole} />
      </Switch>
  );
}
